import { useEffect } from "react";
import { useXR } from "@react-three/xr";

/** Renders nothing; reports XR presentation state to the parent so DOM UI can live outside the R3F Canvas. */
export function PreviewVRSessionSync({ onPresentingChange }) {
  const isPresenting = useXR((s) => s.isPresenting);
  useEffect(() => {
    onPresentingChange(isPresenting);
  }, [isPresenting, onPresentingChange]);
  return null;
}
